<script setup>
import { computed, provide } from "vue";
import { SelectRoot, useForwardPropsEmits } from "reka-ui";
import { reactiveOmit } from "@vueuse/core";

const props = defineProps({
  modelValue: { type: [String, Number, Boolean, Object], default: undefined },
  defaultValue: { type: [String, Number, Boolean, Object], default: undefined },
  open: { type: Boolean, default: undefined },
  defaultOpen: { type: Boolean, default: undefined },
  dir: { type: String, default: undefined },
  name: { type: String, default: undefined },
  autocomplete: { type: String, default: undefined },
  disabled: { type: Boolean, default: undefined },
  required: { type: Boolean, default: undefined },
  size: { type: String, default: "default" }, // sm | default | lg
});

const emits = defineEmits(["update:modelValue", "update:open"]);

const rootProps = reactiveOmit(props, "size");
const forwarded = useForwardPropsEmits(rootProps, emits);

provide(
  "selectSize",
  computed(() => props.size)
);
</script>

<template>
  <SelectRoot v-bind="forwarded" data-slot="select" v-slot="slotProps">
    <slot v-bind="slotProps" />
  </SelectRoot>
</template>
